import React, { useContext, useState } from 'react'
import { Modal, Button, Spinner } from "react-bootstrap"
import { withTranslation } from 'react-i18next'
import moment from 'moment'

import Post from '../../../api/Post'
import { APPOINTMENT_CANCEL } from '../../../api/Routes'
import { authContext } from "../../../context/AuthContext";

import '../../../styles/modal/CancelCita.css'
import { toast } from 'react-toastify'

const CancelCitaModal = ({ t, show, handleHideModal, item, setLoadData, setShowModalServer, setErrorServer }) => {
    const [loading, setLoading] = useState(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    let accesToken = auth.data.access_token;

    const handleDelete = () => {
        const data = {
            id: item?.id,
            appointmentStatus : item?.appointmentStatus
        }

        setLoading(true)

        Post({url: APPOINTMENT_CANCEL, data: data, access_token: accesToken, header: true})
        .then( response => {
            setLoadData( l => !l)
            toast.success(t('accion_exitosa'))
            handleHideModal()
            setLoading(false)
        } )
        .catch( error => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    return <>
        <Modal show={show} onHide={handleHideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{ t('estas_seguro') }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='subtitle'>{ t('eliminar_cita') }:</div>

                <div className='section-info'>
                    <span>{ t('nombre_completo') }: </span>{`${item?.patientDTO?.name} ${item?.patientDTO?.seccondSurname ?? ''} ${item?.patientDTO?.lastName ?? ''} ${item?.patientDTO?.seccondSurname ?? ''}`}<br/>
                    <span>{ t('Correoelectronico') }: </span>{item?.patientDTO?.email}<br/>
                    <span>{ t('Telefono') }: </span>{item?.patientDTO?.phone}
                </div>

                <div className='section-title'>{ t('horarios') }</div>

                <div className='section-info'>
                    <span>{ t('fecha') }: </span>{moment(item?.scheduleDTO?.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format('LLLL')}<br/>
                    <span>{ t('doctor') }: </span>{`Dr. ${item?.scheduleDTO?.doctor?.name} ${item?.scheduleDTO?.doctor?.lastName}`}<br/>
                    <span>{ t('especialidad') }: </span>{item?.speciality.name}
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    !loading ? <div>
                        <Button variant="danger" onClick={ handleDelete }>
                            { t('eliminar') }
                        </Button>
                        <Button variant="link" onClick={ handleHideModal }>
                            { t('regresar') }
                        </Button>
                    </div>
                    : <Spinner animation="border" variant="primary" />
                }
                
            </Modal.Footer>
        </Modal>
    </>
}

export default withTranslation()(CancelCitaModal)